import { render, staticRenderFns } from "./edit-sensor.dialog.component.vue?vue&type=template&id=5ee07e0c"
import script from "./edit-sensor-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-sensor-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports